var _g, _path, _path2, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotfoundLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 83,
    viewBox: "0 0 82 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_2795)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.9012,
    cy: 39.1358,
    rx: 23.9012,
    ry: 24.1358,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.6043 25.0991H27V52.7034H54.6043V25.0991Z",
    fill: "white",
    fillOpacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0956 30.6827L32.556 39.2223C30.5347 41.2436 30.5347 44.5207 32.556 46.542C34.5773 48.5633 37.8544 48.5633 39.8757 46.542L50.0419 36.3758C51.3894 35.0283 51.3894 32.8435 50.0419 31.496C48.6944 30.1485 46.5096 30.1485 45.1621 31.496L34.9959 41.6622C34.3222 42.336 34.3222 43.4283 34.9959 44.1021C35.6696 44.7759 36.762 44.7759 37.4358 44.1021L45.9754 35.5625",
    stroke: "#292C33",
    strokeWidth: 2.01982,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.8904,
    y: 29.7958,
    width: 2.48012,
    height: 28.5254,
    rx: 1.24006,
    transform: "rotate(-43.0461 29.8904 29.7958)",
    fill: "#FFA800",
    stroke: "white",
    strokeWidth: 0.673275
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_2795",
    x: 0.235466,
    y: 0.928564,
    width: 81.3316,
    height: 81.8006,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.6931
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.38227
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_2795"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_2795",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotfoundLink);
export default __webpack_public_path__ + "static/media/notfound-link.a4b2c1f606f5f15c61a88bc09fc6379f.svg";
export { ForwardRef as ReactComponent };